import React, { Component } from 'react';

import {ScrollModifier,ScrollTo,LoaderLink,ViewportProgress,Grid,SiteModifier,FadeIn,Template,Window,Media,Section,Content,ModifierSection,Item} from '../_core/components';

import '../_core/helpers/Array';

// Models
import {Asset,Entry,Data} from '../_core/models';


import {withStore} from '../_core/utils/Store';

// Utils
import * as BreakPoints from '../_core/utils/Breakpoints';

// Project
import * as Project from '../components';


class ProjectPage extends Component {

	lastScroll=0;
	scrolled=0;

	constructor(props) {
		super(props);
		this.state = {};
	}


	setFeature = (id) => {

		let last = this.props.store.get('feature'); 
		this.props.store.store('feature',id,false);
		this.props.store.store('lastFeature',last);
	}

	unsetFeature = (id) => {
	
		this.props.store.store('feature',null,false);
		this.props.store.store('lastFeature',id);

	}

	/*

		RENDER

	*/

	render() {

		let {entry} = this.props;
		if(!entry) return null;


		let content = [...entry.pageContent] || [];
		let related = entry.relatedEntries || [];


		content.unshift({
			type:'text',
			text: entry.body,
			caption : null
		})

		return (
			<ScrollModifier>
			<Template modifiers={['project']} key={entry.id}>

				{/* Scroll to top */}
				<ScrollTo pos={0} duration={0} key={window.location.href} />

				{/* Set BG */}
				<SiteModifier auto modifier={'light'} demodifier={'showToolTip,scrolled,folio,dark'} />

				{/* Template */}
				<FadeIn>

					<ModifierSection modifier={'dark'} demodifier={'light'}>
					{/* Intro */ }
					<div className="Template-intro">
					
						{/* Title */}
						<div className="Template-intro-content">
							<div className="Template-head">
									<Content modifier="header">
										<h1>{ entry.title }</h1>
									</Content>

									<BreakPoints.Mobile>
										<Content modifier="subhead" html={entry.altSubHeading} />
									</BreakPoints.Mobile>
									<BreakPoints.Default>
										<Content modifier="subhead" html={entry.subHeading} />
									</BreakPoints.Default>
								
							</div>
						</div>

						{/* Media */}
						<div className="Template-media">
							<Media id={entry.introImage} fluid={true} />
						</div>
					</div>
					</ModifierSection>
					<ModifierSection modifier={'light'} demodifier={'dark'}>

					{/* Content */}
					<div className="Template-content">
					{content.map((row)=>{

						switch(row.type){

							case 'layout':
							return (

								<div className="Template-section">
									<div className="Container Container--layout">

										<div className="Template-layout">
											<Project.Layout layout={row} />
										</div>
									</div>
								</div>

							)

							case 'image':
							return (

								<div className="Template-section">
									<div className="Container">
										<div className="Template-image">
											<Grid modifiers={[row.size,row.alignment]}>
											{row.images.map(image=>(
												<div key={image} className="Grid-item"><div className={((row.dropShadow && row.dropShadow == 1 ) ? 'Template-shadow': '')}><Media id={image} fluid={false} /></div></div>
											))}
											</Grid>
										</div>
									</div>
								</div>

							)

							case 'text':
							return (

								<div className="Template-section Template-section--text">
									<div className="Container">
										<Grid modifiers={['article']}>
											<div className="Grid-item"><Content modifier="article" html={row.text} /></div>
											<div className="Grid-item"><Content modifier="caption" html={row.caption} /></div>
										</Grid>
									</div>
								</div>

							)

							default:
							return <div>{row.type}</div>;

						}

						return null;

					})}
					</div>

					<div className="Template-video">
						<div className="Template-video-content">
							<div className="Template-video-title">
								<Content modifier="subhead" html={entry.videoTitle} />
							</div>
							<div className="Template-video-player">
								<Media id={entry.videoTrailer} fluid={false} />
							</div>
							<div className="Template-video-credits">
								<Grid modifiers={["credits"]}>
									<div className="Grid-item">
										<Content modifier="credits" html={entry.credits1} />
									</div>
									<div className="Grid-item">
										<Content modifier="credits" html={entry.credits2} />
									</div>
								</Grid>
							</div>
						</div>
					</div>

					<div className="Template-next">
						<Content modifier="next">
							<h1><span>Next</span></h1>
						</Content>
						<ul className="List List--items">
						<Data>
						{({navigation})=>{

							let current = navigation.main.filter(e=>e.id == entry.id);
							let ix = navigation.main.indexOf(current[0]);

							if(ix == (navigation.main.length - 1)){
								ix=0;
							}else{
								ix++;
							}

							let next = navigation.main[ix];


							return (

								<Entry id={[next.id]} render={(e) => (
				                    <li key={e.id} onMouseEnter={()=>{this.setFeature(e.introImage)}} onMouseLeave={()=>{this.unsetFeature(e.introImage)}}>
					                    <LoaderLink to={e.uri} deactivate="#nav">
						                    <div className="Item Item--feature">
							                    <div className="Item-head">
							                    	<Content modifier="next">
										                    		<h1>{e.title}</h1>
										                    	</Content>
							                    </div>
						                    </div>
					                    </LoaderLink>
				                    </li>
				                    )} />

							)

						}}
						</Data>
						</ul>
					</div>
					</ModifierSection>
				</FadeIn>
			</Template>
			</ScrollModifier>
		);

	}
}

export default withStore(ProjectPage);



// WEBPACK FOOTER //
// ./src/js/templates/project.js